/* eslint-disable */

var icon = require('vue-svgicon')
icon.register({
  'courses-1': {
    width: 406,
    height: 424,
    viewBox: '0 0 406 424',
    data: `<path pid="0" _fill="#FFF" fill-opacity=".3" d="M405.089 127.872C358.69 21.165 234.575-27.726 127.867 18.672l-.398-.917c107.213-46.618 231.919 2.505 278.537 109.718l-.917.399zm-277.222-109.2C21.161 65.069-27.73 189.185 18.668 295.892l-.917.4c-46.618-107.214 2.505-231.92 109.718-278.537l.398.917zM18.668 295.892c46.397 106.707 170.513 155.598 277.22 109.2l.399.917C189.073 452.627 64.369 403.504 17.75 296.291l.917-.398z"/>`
  }
})
